module.exports = __webpack_public_path__ + "static/img/69.968ee09b.jpg";